'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Editor = require('./Editor');

var _Editor2 = _interopRequireDefault(_Editor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Editor2.default; /**
                                     * @file: index.js
                                     * @author: Cuttle Cong
                                     * @date: 2017/11/3
                                     * @description: 
                                     */


// WEBPACK FOOTER //
// ./~/picidae-transformer-react-render/~/react-code-editor/lib/index.js